import script from "./CardPhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPhoto.vue?vue&type=script&setup=true&lang=js"

import "./CardPhoto.vue?vue&type=style&index=0&id=09c7e2b6&lang=scss"

const __exports__ = script;

export default __exports__